import React, { useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import {
  Segment,
  Button,
  Icon,
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
  TableBody,
  Table,
  Label,
  Modal,
  ModalHeader,
  ModalContent,
  ModalDescription,
  ModalActions,
  Input,
  Form,
  FormField,
  Checkbox,
  Select,
} from 'semantic-ui-react'
import { toast } from 'react-toastify'

import api from '../../services/api'
import { Container } from './style'

const colors = [
  {
    key: 'red',
    value: 'red',
    text: 'vermelho',
    label: { color: 'red', empty: true, circular: false },
  },
  {
    key: 'orange',
    value: 'orange',
    text: 'laranja',
    label: { color: 'orange', empty: true, circular: false },
  },
  {
    key: 'yellow',
    value: 'yellow',
    text: 'amarelo',
    label: { color: 'yellow', empty: true, circular: false },
  },
  {
    key: 'olive',
    value: 'olive',
    text: 'azeitona',
    label: { color: 'olive', empty: true, circular: false },
  },
  {
    key: 'green',
    value: 'green',
    text: 'verde',
    label: { color: 'green', empty: true, circular: false },
  },
  {
    key: 'teal',
    value: 'teal',
    text: 'azul-petróleo',
    label: { color: 'teal', empty: true, circular: false },
  },
  {
    key: 'blue',
    value: 'blue',
    text: 'azul',
    label: { color: 'blue', empty: true, circular: false },
  },
  {
    key: 'violet',
    value: 'violet',
    text: 'violeta',
    label: { color: 'violet', empty: true, circular: false },
  },
  {
    key: 'purple',
    value: 'purple',
    text: 'roxo',
    label: { color: 'purple', empty: true, circular: false },
  },
  {
    key: 'pink',
    value: 'pink',
    text: 'rosa',
    label: { color: 'pink', empty: true, circular: false },
  },
  {
    key: 'brown',
    value: 'brown',
    text: 'marrom',
    label: { color: 'brown', empty: true, circular: false },
  },
  {
    key: 'grey',
    value: 'grey',
    text: 'cinza',
    label: { color: 'grey', empty: true, circular: false },
  },
  {
    key: 'black',
    value: 'black',
    text: 'preto',
    label: { color: 'black', empty: true, circular: false },
  },
]

export default function TicketStatus() {
  const profile = useSelector((state) => state.user.profile)
  const [statuses, setStatuses] = useState([])
  const [modalAddOpen, setModalAddOpen] = useState(false)

  const [addAtivo, setAddAtivo] = useState(true)
  const [addNome, setAddNome] = useState('')
  const [addColor, setAddColor] = useState('green')

  const [modalEditOpen, setModalEditOpen] = useState(false)
  const [editStatusId, setEditStatusId] = useState(0)
  const [editStatusEnabled, setEditStatusEnabled] = useState(false)
  const [editStatusName, setEditStatusName] = useState('')
  const [editStatusColor, setEditStatusColor] = useState('green')

  const [modalRemoveOpen, setModalRemoveOpen] = useState(false)
  const [removeStatusId, setRemoveStatusId] = useState(0)
  const [removeStatusName, setRemoveStatusName] = useState('')

  const fetchStatuses = useCallback(async () => {
    try {
      const response = await api.get(
        `/domains/${profile.id_dominio}/ticketstatus`,
      )
      setStatuses(response.data)
    } catch (error) {
      console.error('Error fetching statuses:', error)
      toast.error('Failed to fetch statuses')
    }
  }, [profile])

  const handleAddStatus = useCallback(async () => {
    try {
      if (!addNome) {
        toast.error('Nome do status é obrigatório')
        return
      }

      await api.post(`/domains/${profile.id_dominio}/ticketstatus`, {
        nome: addNome,
        ativo: addAtivo,
        global: false,
        color: addColor,
        can_be_deleted: true,
      })
      await fetchStatuses()
      setModalAddOpen(false)
      setAddAtivo(true)
      setAddNome('')
      setAddColor('green')
      toast.success('Status adicionado com sucesso')
    } catch (error) {
      console.error('Error adding status:', error)
      toast.error('Erro ai adicionar status')
    }
  }, [addAtivo, addNome, addColor, profile, fetchStatuses])

  const handleEditStatus = useCallback(async () => {
    try {
      if (!editStatusName) {
        toast.error('Nome do status é obrigatório')
        return
      }

      await api.put(
        `/domains/${profile.id_dominio}/ticketstatus/${editStatusId}`,
        {
          nome: editStatusName,
          ativo: editStatusEnabled,
          global: false,
          color: editStatusColor,
          can_be_deleted: true,
        },
      )
      await fetchStatuses()
      setModalEditOpen(false)
      setEditStatusId(0)
      setEditStatusEnabled(false)
      setEditStatusName('')
      setEditStatusColor('green')
      toast.success('Status atualizado com sucesso')
    } catch (error) {
      console.error('Error updating status:', error)
      toast.error('Erro ao atualizar status')
    }
  }, [
    editStatusId,
    editStatusEnabled,
    editStatusName,
    editStatusColor,
    profile,
    fetchStatuses,
  ])

  useEffect(() => {
    if (profile?.id_dominio) {
      fetchStatuses()
    }
  }, [fetchStatuses, profile])

  return (
    <Container>
      <Segment color="blue" className="div-tamanho">
        <Button
          icon
          labelPosition="left"
          primary
          size="small"
          onClick={() => {
            // setOpenModalDomain(true)
            setModalAddOpen(true)
          }}
        >
          <Icon name="plus" /> Adicionar Status
        </Button>
        <div className="table-container">
          <Table celled>
            <TableHeader>
              <TableRow>
                <TableHeaderCell textAlign="center">#ID</TableHeaderCell>
                <TableHeaderCell>Nome</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Global</TableHeaderCell>
                <TableHeaderCell>Cor</TableHeaderCell>
                <TableHeaderCell>Pode Ser Removido</TableHeaderCell>
                <TableHeaderCell />
              </TableRow>
            </TableHeader>

            <TableBody>
              {statuses?.map((status) => (
                <TableRow key={status.id}>
                  <TableCell textAlign="center">{status.id}</TableCell>
                  <TableCell>{status.nome}</TableCell>
                  <TableCell negative={!status.ativo} positive={status.ativo}>
                    {!status.ativo && <Icon name="close" />}
                    {status.ativo && <Icon name="checkmark" />}
                    {status.ativo ? 'Ativo' : 'Inativo'}
                  </TableCell>
                  <TableCell negative={!status.global} positive={status.global}>
                    {!status.global && <Icon name="close" />}
                    {status.global && <Icon name="checkmark" />}
                    {status.global ? 'Sim' : 'Não'}
                  </TableCell>
                  <TableCell color={status.color} textAlign="center">
                    <Label color={status.color} empty>
                      {colors.find((c) => c.value === status.color)?.text || ''}
                    </Label>
                  </TableCell>
                  <TableCell
                    negative={!status.can_be_deleted}
                    positive={status.can_be_deleted}
                  >
                    {!status.can_be_deleted && <Icon name="close" />}
                    {status.can_be_deleted && <Icon name="checkmark" />}
                    {status.can_be_deleted ? 'Sim' : 'Não'}
                  </TableCell>
                  <TableCell>
                    {!status.global && (
                      <Button
                        icon
                        color="blue"
                        onClick={() => {
                          setEditStatusId(status.id)
                          setEditStatusEnabled(status.ativo)
                          setEditStatusName(status.nome)
                          setEditStatusColor(status.color)
                          setModalEditOpen(true)
                        }}
                      >
                        <Icon name="pencil alternate" />
                      </Button>
                    )}
                    {status.can_be_deleted && (
                      <Button
                        icon
                        color="red"
                        onClick={() => {
                          setRemoveStatusId(status.id)
                          setRemoveStatusName(status.nome)
                          setModalRemoveOpen(true)
                        }}
                      >
                        <Icon name="trash alternate outline" />
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Segment>

      {/* Modal Add Status */}
      <Modal
        onClose={() => setModalAddOpen(false)}
        onOpen={() => setModalAddOpen(true)}
        open={modalAddOpen}
        size={'mini'}
      >
        <ModalHeader>Adicionar Status para Chamado</ModalHeader>
        <ModalContent>
          <ModalDescription>
            <Form>
              <FormField
                control={Checkbox}
                label="Ativo"
                checked={addAtivo}
                onChange={(e) => setAddAtivo(!addAtivo)}
              />
              <FormField
                id="form-input-control-first-name"
                control={Input}
                label="Nome"
                placeholder="Nome"
                value={addNome}
                onChange={(e) => setAddNome(e.target.value)}
              />
              <FormField
                id="form-input-control-color"
                control={Select}
                options={colors}
                color="yellow"
                label={{
                  children: 'Cor',
                  htmlFor: 'form-input-control-color',
                }}
                // label="Cor"
                placeholder="Cor"
                search
                searchInput={{ id: 'form-input-control-color' }}
                value={addColor}
                defaultValue={addColor}
                onChange={(e, v) => {
                  setAddColor(v.value)
                }}
              />
            </Form>
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button color="black" onClick={() => setModalAddOpen(false)}>
            Cancelar
          </Button>
          <Button
            content="Adicionar"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              handleAddStatus()
              setModalAddOpen(false)
            }}
            positive
          />
        </ModalActions>
      </Modal>

      {/* Modal Edit Status */}
      <Modal
        onClose={() => setModalEditOpen(false)}
        onOpen={() => setModalEditOpen(true)}
        open={modalEditOpen}
        size={'mini'}
      >
        <ModalHeader>Alterar Status</ModalHeader>
        <ModalContent>
          <ModalDescription>
            <Form>
              <FormField
                control={Checkbox}
                label="Ativo"
                checked={editStatusEnabled}
                onChange={(e) => setEditStatusEnabled(!editStatusEnabled)}
              />
              <FormField
                id="form-input-control-first-name"
                control={Input}
                label="Nome"
                placeholder="Nome"
                value={editStatusName}
                onChange={(e) => setEditStatusName(e.target.value)}
              />
              <FormField
                id="form-input-control-color"
                control={Select}
                options={colors}
                color="yellow"
                label={{
                  children: 'Cor',
                  htmlFor: 'form-input-control-color',
                }}
                // label="Cor"
                placeholder="Cor"
                search
                searchInput={{ id: 'form-input-control-color' }}
                value={editStatusColor}
                defaultValue={editStatusColor}
                onChange={(e, v) => {
                  setEditStatusColor(v.value)
                }}
              />
            </Form>
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button color="black" onClick={() => setModalEditOpen(false)}>
            Cancelar
          </Button>
          <Button
            content="Alterar"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              handleEditStatus()
              setModalEditOpen(false)
            }}
            positive
          />
        </ModalActions>
      </Modal>

      {/* Modal Remove Status */}
      <Modal
        onClose={() => setModalRemoveOpen(false)}
        onOpen={() => setModalRemoveOpen(true)}
        open={modalRemoveOpen}
        size={'small'}
      >
        <ModalHeader>Remover Status</ModalHeader>
        <ModalContent>
          <ModalDescription>
            <p>
              Tem certeza que deseja remover o status:
              <br />
              <strong>{removeStatusName}</strong>?
            </p>
            <p>
              Esta ação não pode ser desfeita e o status será removido de todos
              os chamados associados.
            </p>
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button color="black" onClick={() => setModalRemoveOpen(false)}>
            Cancelar
          </Button>
          <Button
            content="Remover"
            labelPosition="right"
            icon="trash alternate outline"
            onClick={async () => {
              try {
                await api.delete(
                  `/domains/${profile.id_dominio}/ticketstatus/${removeStatusId}`,
                )
                await fetchStatuses()
                setModalRemoveOpen(false)
                setRemoveStatusId(0)
                setRemoveStatusName('')
                toast.success('Status removido com sucesso')
              } catch (error) {
                console.error('Error removing status:', error)
                toast.error('Erro ao remover status')
              }
            }}
            negative
          />
        </ModalActions>
      </Modal>
    </Container>
  )
}
